import React                        from 'react';
import { minTraceSpace }            from 'pu-data/SelectOptions';
import { minTraceSpace as tooltip } from 'pu-data/Tooltips';
import CheckboxComponent            from './CheckboxComponent';

// const onChangeParameterMinTrace =

const MinTraceSpace = (props) => {
  const name = 'min_trace_space';
  const onChange = e => props.onChangeParameter(name, e.target.checked ? '1' : '0')
  return (
    <CheckboxComponent
      name={name}
      inputId={name}
      label={props.label}
      tooltip={props.tooltip}
      checked={props.checked || props.parameters[name] === '1'}
      drawHidden={props.drawHidden}
      value={props.value}
      onChange={props.onChange || onChange} />
  );
};

MinTraceSpace.defaultProps = {
  drawHidden: true,
  options   : minTraceSpace,
  tooltip,
  label     : 'Min. Trace<br class="d-none d-lg-block" /> Space',
};

export default MinTraceSpace;
